export default "__VITE_ASSET__BuGF9zcD__"